/**
 * Returns true if the given hex color is light enough to require dark (black) text
 * for adequate contrast, based on WCAG relative luminance.
 */
export function needsDarkText(hex: string): boolean {
  const clean = hex.replace('#', '')
  const expanded =
    clean.length === 3 ? clean.split('').map(c => c + c).join('') : clean
  if (expanded.length !== 6) return false
  const r = parseInt(expanded.slice(0, 2), 16) / 255
  const g = parseInt(expanded.slice(2, 4), 16) / 255
  const b = parseInt(expanded.slice(4, 6), 16) / 255
  const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b
  return luminance > 0.8
}
